import { Component, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { LineGraphComponent } from "./components/line-graph/line-graph.component";
import { SearchParameterService } from "app_dashboard/service/search-parameter.service";
import {
    EGraphType,
    IDashboardConfig,
    IDashboardConfigData, IDashboardFilterFormField,
    IDashboardFilters,
    IDashboardSearchParameter
} from "libraries/interfaces/i-dashboard-config";
import { BarGraphComponent } from "./components/bar-graph/bar-graph.component";
import { SunburstGraphComponent } from "./components/sunburst-graph/sunburst-graph.component";
import { RotatebarGraphComponent } from "./components/rotatebar-graph/rotatebar-graph.component";
import { ActivatedRoute, Params } from "@angular/router";
import { NumberGraphComponent } from "./components/number-graph/number-graph.component";
import { SearchHeaderComponent } from "./components/search-header/search-header.component";
import { Yii } from "libraries/interfaces/Yii";
import { DashboardDomainService } from "app_dashboard/service/dashboard-domain.service";
import { Observable } from "rxjs";
import { flatMap } from "rxjs/internal/operators";
import { LabelService } from "libraries/service/label/label.service";
import { TitleService } from "../../service/title/title.service";
import { MultipleBarGraphComponent } from "./components/multiple-bar-graph/multiple-bar-graph.component";
import { LocalizedPipe } from "libraries/pipes/localized/localized.pipe";
import { TLocalizedString } from "libraries/pipes/localized/localized.interface";


export class Wording {
    public readonly noType: string = Yii.t('wui-dashboard-js', 'type non défini');
    public readonly noData: string = Yii.t('wui-dashboard-js', 'Aucune donnée');
}

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard-page.component.html',
    styleUrls: [
        './dashboard-page.component.scss',
    ]
})
export class DashboardPageComponent implements OnInit {

    @ViewChildren('line')
    public lineGraphs: QueryList<LineGraphComponent>;
    @ViewChildren('bar')
    public barGraphs: QueryList<BarGraphComponent>;
    @ViewChildren('sunburst')
    public sunburstGraphs: QueryList<SunburstGraphComponent>;
    @ViewChildren('rotatebar')
    public rotatebarGraphs: QueryList<RotatebarGraphComponent>;
    @ViewChildren('number')
    public numberGraphs: QueryList<NumberGraphComponent>;
    @ViewChildren('multipleBar')
    public multipleBarGraphs: QueryList<MultipleBarGraphComponent>;
    @ViewChild("header")
    public headerComponent: SearchHeaderComponent;

    public config: IDashboardConfigData[][];
    public graphType: typeof EGraphType = EGraphType;
    public dashboardFiltersConfiguration: IDashboardFilters;
    public dashboardCriteriaConfiguration: IDashboardFilters;

    public displayError: boolean = false;
    public errorString: string = "";
    public defaultClass: string = 'sizeN';

    public index: string;

    public wording: Wording = new Wording();
    public dashboardName: string;

    constructor(
        private readonly searchParameterService: SearchParameterService,
        private readonly route: ActivatedRoute,
        private readonly dashboardDomainService: DashboardDomainService,
        private readonly labelService: LabelService,
        private readonly titleService: TitleService,
        private readonly localizedPipe: LocalizedPipe,
    ) {
    }

    public ngOnInit(): void {
        let routeParams: Params;
        this.route.queryParams
            .pipe(
                flatMap((params: Params): Observable<IDashboardConfig[]> => {
                    routeParams = params;
                    return this.dashboardDomainService.getConfiguration();
                })
            )
            .subscribe((config: IDashboardConfig[]): void => {
                    const dashboardConfig: IDashboardConfig[] = config;
                    const configId: number = Number(this.route.snapshot.params.id);
                    if (configId < dashboardConfig.length) {
                        const id: number = this.route.snapshot.params.id;
                        this.config = dashboardConfig[id].data;
                        this.index = dashboardConfig[id].index;
                        this.dashboardFiltersConfiguration = dashboardConfig[id].filters;
                        this.dashboardCriteriaConfiguration = dashboardConfig[id].criteria;

                        const searchParameters: IDashboardSearchParameter = {};
                        this.dashboardFiltersConfiguration.formFields
                            .forEach((filter: IDashboardFilterFormField): void => {
                                searchParameters[filter.code] = routeParams[filter.code] ? filter.type === "date" ?
                                    new Date(`${routeParams[filter.code]}GMT+0000`) :
                                    routeParams[filter.code] : undefined;
                            });
                        this.dashboardCriteriaConfiguration.formFields
                            .forEach((filter: IDashboardFilterFormField): void => {
                                searchParameters[filter.code] = routeParams[filter.code] ? filter.type === "date" ?
                                    new Date(`${routeParams[filter.code]}GMT+0000`) :
                                    routeParams[filter.code] : undefined;
                            });

                        this.initDashboardName(dashboardConfig[id].nameArray || dashboardConfig[id].name);
                        this.titleService.setTitle(this.dashboardName);
                    } else {
                        this.displayError = true;
                        const test: string = Yii.t("wui-dashboard-js", "truc pour débloquer le build encore");
                        this.errorString =
                            this.labelService.completeLabel(
                                Yii.t("wui-dashboard-js", "Aucune configuration trouvée pour l'id %id%."),
                                {
                                    id: this.route.snapshot.params.id,
                                }
                            );
                    }
                }
            );
    }

    private initDashboardName(name: TLocalizedString): void {
        this.dashboardName = this.localizedPipe.transform(name);
    }

    public search(): void {
        this.headerComponent.request();
        const graph: any[] = [this.lineGraphs, this.barGraphs, this.rotatebarGraphs, this.sunburstGraphs, this.numberGraphs, this.multipleBarGraphs];
        graph.forEach((element: any): void => {
            element.forEach((item: any): void => {
                item.request();
                item.resize();
            });
        });
    }
}
